import { Circle, Home, PlusSquare, Users } from 'react-feather';

import { getUserProjSection, getAccessToken, axios, aesEncrypt } from 'utils/common';

class UserAccessService {
  getProjectList() {
    const URL = `Users/Proj`;

    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
  getProductList() {
    const URL = `Users/Prod`;

    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
  getLeftMenu(params) {
    const URL = `Users/${params.prodid}/Section`;

    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }

  getAppDeviceVersions({ projId, appVersionName } = {}) {
    const URL = `Users/AppVersion`;

    return axios({
      method: 'get',
      url: URL,
      params: {
        ...(projId ? { projId } : {}),
        ...(appVersionName ? { appVersionName } : {})
      },
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
  forgotPassword(loginid) {
    const URL = `Authentications/ForgotPassword`;

    return axios({
      method: 'get',
      params: {
        loginid
      },
      url: URL
    });
  }

  resetPassword(data) {
    const URL = `Authentications/ResetPassword`;

    return axios({
      method: 'post',
      url: URL,
      data: {
        Token: data.Token,
        Password: aesEncrypt(data.Password),
        ConfirmPassword: aesEncrypt(data.ConfirmPassword)
      }
    });
  }
}
export default new UserAccessService();
